import { Component, computed, inject, input, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { SessionFacade } from '@app/store/session';
import { LogoComponent } from '@shared/components';
import { MENU_ITEMS, visibleMenuItems } from './menu-items';
import { AccountComponent } from './account/account.component';
import { MenuItemComponent } from './menu-item/menu-item.component';
import { MenuHeaderComponent } from './menu-header/menu-header.component';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css'],
    host: { class: 'theme-dark', '[class.open]': 'open()' },

    imports: [RouterLink, TranslatePipe, LogoComponent, AccountComponent, MenuItemComponent, MenuHeaderComponent],
})
export class SidebarComponent {
    private readonly sessionFacade = inject(SessionFacade);

    readonly open = input(false);

    readonly menuItems = computed(() => visibleMenuItems((permission) => this.sessionFacade.hasPermission(permission)));

    private readonly collapsedHeaders = signal(new Set(MENU_ITEMS.filter((item) => item.collapsed).map((item) => item.label)));

    isCollapsed(label: string): boolean {
        return this.collapsedHeaders().has(label);
    }

    toggleHeader(label: string): void {
        const next = new Set(this.collapsedHeaders());
        if (next.has(label)) {
            next.delete(label);
        } else {
            next.add(label);
        }
        this.collapsedHeaders.set(next);
    }
}
